import { defineStore } from 'pinia';
import chinaExternalLink from '../../../locales/ops/deploy/china/config/externalLink.json';
import globalExternalLink from '../../../locales/ops/deploy/global/config/externalLink.json';
import datasetTemplateDownloadLink from '../../../locales/ops/deploy/base/config/templateLink.json';
import { useUserStore } from './user';
import { AppMode } from '/@/api/sys/model/userModel';

interface ILink {
  externalLink: any;
  templateLink: any;
}

export const useLinkStore = defineStore({
  id: 'app-link',
  state: (): ILink => ({
    externalLink: {},
    templateLink: {},
  }),
  actions: {
    async getExternalLink() {
      const userStore = useUserStore();
      const runningMode = userStore?.getGlobalConfig?.runningMode;
      try {
        const externalLinkRes = await fetch('/config/externalLink.json', {
          cache: 'no-cache',
        });
        this.externalLink = (await externalLinkRes.json()) ?? {};
      } catch (error) {
        this.externalLink = {};
        this.externalLink = runningMode == AppMode.China ? chinaExternalLink : globalExternalLink;
      }

      try {
        const templateLinkRes = await fetch('/config/templateLink.json', {
          cache: 'no-cache',
        });
        this.templateLink = (await templateLinkRes.json()) ?? {};
      } catch (error) {
        this.templateLink = {};
        this.templateLink = datasetTemplateDownloadLink;
      }

      // console.log('externalLink', this.externalLink);
      // console.log('templateLink', this.templateLink);
    },
  },
});
